import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '../../lib/adminApi';

export function Login({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await adminApi.login(password);
      onAuthenticated();
    } catch {
      setError('That password wasn’t right. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="cms-login">
      <form onSubmit={submit}>
        <div className="cms-brand"><span className="cms-brand-mark">S</span><span><b>Sugarloaf</b><small>Goldens CMS</small></span></div>
        <h1>Welcome back</h1>
        <p>Sign in to manage your litters, leads, and inbox.</p>
        <label>
          Password
          <input autoFocus type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} aria-invalid={Boolean(error)} />
        </label>
        {error && <p className="cms-login-error" role="alert">{error}</p>}
        <button type="submit" className="cms-btn cms-btn-primary" disabled={busy || !password}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <Link to="/" className="cms-login-back">← Back to the site</Link>
      </form>
    </div>
  );
}
